import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Refunds() {
  return (
    <LegalPage
      title="Refund & Cancellation Policy"
      lastUpdated="May 21, 2026"
      testid="refunds-page"
    >
      <p>
        We want you to feel good about paying for Colleague — and to feel okay
        when you decide to step away.
      </p>

      <h2 className="font-serif text-2xl text-[#2D2926] mt-10">
        Cancellation
      </h2>
      <p>
        You can stop paying for Colleague at any time. Because we do not
        auto-renew, "canceling" just means not buying your next month or year
        when the current one ends. There's nothing to opt out of.
      </p>
      <p>
        When your paid access expires, your account stays intact — your
        conversations, personas, profile, and vibe history all remain. You can
        log in and read them any time. You'll only need to subscribe again to
        send new messages, use voice notes, or generate avatars.
      </p>

      <h2 className="font-serif text-2xl text-[#2D2926] mt-10">
        Refund policy
      </h2>
      <p>
        Colleague+ subscriptions are non-refundable by default, with two
        exceptions:
      </p>

      <h3 className="font-serif text-xl text-[#2D2926] mt-6">
        Within 7 days of purchase — full refund, no questions asked
      </h3>
      <p>
        If you bought Colleague+ in the last 7 days and it isn't working for
        you, email us and we'll refund you in full. No interrogation, no
        cancellation survey. Subject line: "refund please" is enough.
      </p>

      <h3 className="font-serif text-xl text-[#2D2926] mt-6">
        Service outages
      </h3>
      <p>
        If Colleague is unavailable for 48 consecutive hours, contact us and
        we'll prorate or extend your subscription accordingly.
      </p>

      <h2 className="font-serif text-2xl text-[#2D2926] mt-10">
        How to request a refund
      </h2>
      <p>
        Email{" "}
        <a
          href="mailto:hello@meetacolleague.com"
          className="text-[#D4A574] hover:text-[#C99560] underline"
        >
          hello@meetacolleague.com
        </a>{" "}
        from the email address on your Colleague account. Refunds are
        processed via Stripe and typically appear on your card within 5–10
        business days.
      </p>

      <h2 className="font-serif text-2xl text-[#2D2926] mt-10">
        Account deletion
      </h2>
      <p>
        If you want your account and all conversations permanently deleted,
        email us — same address. We'll confirm via email and remove everything
        within 30 days, except where law requires us to keep payment records
        longer.
      </p>
    </LegalPage>
  );
}
